import { createFeatureSelector, createSelector } from '@ngrx/store';

import { adapter } from './reference-value-sheet.reducer';
import { RefValSheetModuleState } from '../models/reference-value-sheet.model';

const { selectAll } = adapter.getSelectors();

export const getRefValSheetModuleState = createFeatureSelector<RefValSheetModuleState>(
  'referenceValueSheetModule',
);
export const getReferenceValueSheetsState = createSelector(
  getRefValSheetModuleState,
  (state) => state.refValSheets,
);

export const getReferenceValueSheets = createSelector(getReferenceValueSheetsState, selectAll);

export const getBaseReferenceValueSheet = createSelector(
  getRefValSheetModuleState,
  (state) => state.baseRefValSheet,
);

export const getStandardReferenceValueSheets = createSelector(
  getReferenceValueSheets,
  (refValSheets) => refValSheets.filter((r) => r.isStandardReferenceValueSheet && r.isActive),
);

export const getSelectedCountry = createSelector(
  getRefValSheetModuleState,
  (state) => state.selectedCountry,
);

export const getColumnSettings = createSelector(
  getRefValSheetModuleState,
  (state) => state.columns,
);
